<template> 
  <section class="form-login">
    <Loader v-if="loading" />

    <b-form class="custom-form text-left" @submit.prevent="submit">
      <div class="form-group">
        <label for="password">Nueva contraseña</label>

        <FormInput
          id="password"
          type="password"
          placeholder="Ingresa tu nueva contraseña"
          :show-error="$v.form.password.$error && !$v.form.password.required"
          v-model="form.password"
        />

        <form-error
          message="Nueva contraseña es requerida"
          v-if="$v.form.password.$error && !$v.form.password.required"
        />
      </div>

      <div class="form-group">
        <label for="password2">Confirmar contraseña</label>

        <FormInput
          id="password2"
          type="password"
          placeholder="Ingresa tu nueva contraseña"
          :show-error="$v.form.password2.$error"
          v-model="form.password2"
        />

        <form-error
          message="Confirmación de contraseña es requerida"
          v-if="$v.form.password2.$error && !$v.form.password2.required"
        />

        <!-- Muestra este error solo si el campo no está vacío (required pasa) pero no coincide -->
        <form-error
          message="Las contraseñas no coinciden"
          v-if="$v.form.password2.$error && $v.form.password2.required && !$v.form.password2.sameAsPassword"
        />
      </div>

      <b-button class="button button-primary mt-2" type="submit" variant="none" block>
        Actualizar contraseña
      </b-button>

      <div class="d-flex justify-content-center align-items-center w-100 text-center">
        <router-link to="/login" class="text-color-primary font-weight-light ml-2">
          <i class="ri-arrow-left-s-line"></i> Volver al inicio
        </router-link>
      </div>
    </b-form>
  </section>
</template>

<script>
import { FormError, FormInput, Loader, Alert } from "wize-admin";
import { required, sameAs } from "vuelidate/lib/validators";
import { SecurityService } from "@/core/services";

export default {
  components: { FormError, Loader, FormInput },
  data() {
    return {
      form: {
        password: null,
        password2: null,
      },
      loading: false,
    };
  },
  validations: {
    form: {
      password: { required },
      password2: {
        required,
        sameAsPassword: sameAs('password'), // Debe ser igual a form.password
      },
    },
  },
  methods: {
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) return;

      try {
        this.loading = true;
        const resp = await SecurityService.updatePassword({ password: this.form.password, recoveryToken: this.$route.params.token });

        if(resp.status == 'OK') {
          Alert.success("Tu contraseña ha sido actualizada exitosamente.")

          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 2000);
        } else {
          Alert.error(resp.payload[0].defaultMessage)
        }

        this.loading = false;
      } catch (e) {
        console.error(e)
        if(e.errors.message) {
          Alert.error(e.errors.message)
        } else {
          Alert.error(e);
        }
      } finally {
        this.loading = false;
      }
    },
    showRecaptchaBadge() {
      if (this.$recaptchaInstance) this.$recaptchaInstance.showBadge();
      else setTimeout(this.showRecaptchaBadge, 500);
    },
  },
  mounted() {
    // this.showRecaptchaBadge();
  },
};
</script>

<style lang="stylus">
@import './form-login';
</style>
